import React from "react";
import ReactTooltip from "react-tooltip";
import styled from "@emotion/styled";

const TooltipImage = styled.img`
  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
`;

const TradeOptionTooltip = () => {
  return (
    <div>
      <ReactTooltip
        effect="solid"
        className="tooltip-brand-page-shield"
        id={`sellTooltip`}
      />
      <span
        className="sellTooltip-span"
        data-offset="{'left': 30}"
        data-for={`sellTooltip`}
        data-tip="Get paid faster"
      >
        <TooltipImage
          src="https://cdn.cardcash.com/website/ui/elements/basic%20icons%20info.svg"
          alt="icon"
        />
      </span>
    </div>
  );
};

export default TradeOptionTooltip;
